import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'min',
  standalone: true,
})
export class MinPipe implements PipeTransform {
  transform(val: number, compare: number): number {
    return Math.min(val, compare);
  }
}
